import React, { useMemo } from "react";
import { cn } from "../../utils/TwMerge";
import { useSelector, useDispatch } from "react-redux";
import { motion } from "framer-motion";
import { SETSTORETYPE } from "../../redux/features/store";
import Konsole from "../../utils/konsole/Konsole";
import { useTranslation } from "react-i18next";
import { DELIVERY_STATUS } from "../../utils/helper";
interface DeliveryToggleProps {
  onSelectionChange?: (value: "3" | "2") => void;
  defaultValue?: any;
}

const DeliveryToggle = ({ onSelectionChange, defaultValue = DELIVERY_STATUS, }: DeliveryToggleProps) => {
  const dispatch = useDispatch()
  const { store: { selectedType, storeDeliveryPickupType }, } = useSelector((state: any) => state);
  const { t } = useTranslation()
  Konsole.log('defaultValue', defaultValue)
  // @@ function update selection box (Delivery and Pickup)
  const handleSelect = (value: any) => {
    onSelectionChange?.(value);
    const idSelection = value == '3' ? 3 : 1;
    sessionStorage.setItem("store_type",JSON.stringify(idSelection))
    dispatch(SETSTORETYPE(idSelection))
  };


  // @@ set default delivery 
  //  const storeType = sessionStorage.getItem("store_type") || '3';
  // useEffect(() => {
  //   if(!selectedType)
  //   handleSelect(storeType)
  // }, [])


  const isDelivery = useMemo(() => {
    return storeDeliveryPickupType?.delivery == true
  }, [storeDeliveryPickupType])

  const isPickup = useMemo(() => {
    return storeDeliveryPickupType?.pickup == true
  }, [storeDeliveryPickupType])
  //   let isServiceAvail=useMemo(()=>{
  //     let isPickup=storeDeliveryPickupType?.pickup==true ;
  //     let isDelivery=storeDeliveryPickupType?.delivery==true;
  //     let bothDisplay=(isPickup==true) &&  (isDelivery==true);
  //     return {
  // bothDisplay,
  // isDelivery,
  // isPickup
  //     }
  //   },[storeDeliveryPickupType])
  // Konsole.log('storeDeliveryPickupType', selectedType, storeDeliveryPickupType)

  return (
    <div className="inline-flex md:w-auto w-full items-center rounded-full p-1 bg-[#E8E8E8] relative md-width">
      <motion.div
        className="absolute top-1 left-1 bottom-1 rounded-full bg-white"
        initial={false}
        animate={{
          x: selectedType == "3" ? 0 : "100%",
          width: selectedType == "3" ? "calc(50% - 4px)" : (selectedType == '1') ? "calc(50% - 4px)" : '100%',
        }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      />


      {(storeDeliveryPickupType?.isPickupNDelivery) ? <>

        <button
          disabled={!isDelivery}
          onClick={() => handleSelect("3")}
          className={cn(
            "px-6 py-1.5 text-sm font-medium rounded-full transition-colors relative z-[9] w-full delivery-btn",
            selectedType == DELIVERY_STATUS ? "text-primary-foreground" : "text-foreground hover:text-primary"
          )}
          style={{ lineHeight: (!isDelivery || !isPickup) ? '.7rem' : '1.25rem',paddingTop:".5rem" }}
        >
          {t("Checkout.delivery")}
          {!isDelivery && <><br /> <span style={{ fontSize: "10px", color: "gray" }}>{t("Checkout.unavailable")}</span></>}
        </button>
        <button
          style={{ lineHeight: (!isDelivery || !isPickup) ? '.7rem' : '1.25rem',paddingTop:".5rem" }}
          disabled={!isPickup}
          onClick={() => handleSelect("1")}
          className={cn(
            "px-6 py-1.5 text-sm font-medium rounded-full transition-colors relative z-[9] w-full delivery-btn",
            selectedType == "1" ? "text-primary-foreground" : "text-foreground hover:text-primary"
          )}
        >
          {t("Checkout.pickup")}
          {!isPickup && <><br /> <span style={{ fontSize: "10px", color: "gray" }}>{t("Checkout.unavailable")}</span></>}
        </button>
      </> : <button
        disabled
        className={cn("px-6 py-1.5 text-sm font-medium rounded-full transition-colors relative z-[9] w-full text-primary-foreground",)}
      >
        {t("Checkout.currentlyWeDoNotProvideAnyService")}
      </button>}

    </div>
  );
};
export default DeliveryToggle;
